import React, { Component, useState } from 'react';
import { observer } from 'mobx-react';
import { unmountComponentAtNode } from 'react-dom';

import Svg from '../components/svg-icon';
import BaseOverlay from '../components/overlay';
import { initChooseYourPriceApp } from '../choose-your-price';

const Overlay = ({ children, onCloseCB }) => {
  const [isOpen, setIsOpen] = useState(true);
  const onClose = () => {
    if (onCloseCB) {
      onCloseCB();
    }

    setIsOpen(false);
    history.pushState('', document.title, window.location.pathname);

    setTimeout(() => {
      const els = document.querySelectorAll('[data-overlay]');
      els.forEach((el) => {
        unmountComponentAtNode(el);
      });
    }, 350);
  };
  return (
    <div className={ `modal ${ isOpen ? 'is-open' : '' }` } aria-hidden={ isOpen ? 'false' : 'true' }>
      <BaseOverlay onClose={ onClose }>
        { children }
      </BaseOverlay>
    </div>
  );
};

const Calendar = ({ months, days, datesLength }) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <>
      <div className='filter-group--mobile-controls --calendar'>
        <div className='w-100'>
          <a className={ `link--stubby ${ isOpen ? 'collapse-control--open' : '' }` } onClick={ () => setIsOpen(!isOpen) }>
            <span>
              Choose dates
              <i className='icon ml-2 triangle-down inline-block'>
                <Svg name='icon-triangle-down' width='10px' height='5px' className='color-black' />
              </i>
            </span>
          </a>
        </div>
      </div>
      <div className={ `calendar-wrapper collapse ${ isOpen ? 'collapsible-show' : '' }` }>
        <div className={ `calendar--grid md-down:overflow-wrapper grid-columns--${ datesLength }` }>
          { months }
          { days }
        </div>
      </div>
    </>
  );
};

const CalendarMonth = ({ name, datesLength }) => {
  return (
    <span className={ `block calendar__month 2 grid-span--${ datesLength }` }>
      <h6>
        { name }
      </h6>
    </span>
  );
};

const CalendarDay = ({ isWeekend, isCurrent, isActive, dayInitial, date, onClick }) => {
  return (
    <div className={
      'calendar__day '
      + `${ isWeekend ? '--weekend' : '' } ${ !isActive ? '--disabled' : '' } ${ isCurrent ? '--selected' : '' }`
    }
    >
      <p className='small'>
        <span>{ dayInitial }</span>
        <br />
        <a className='stretched-link link--no-hover' onClick={ onClick }>
          { date }
        </a>
      </p>
    </div>
  );
};

const EventList = ({ title, filters, calendar, events, displayLargeTiles }) => {
  return (
    <>
      <div className='filter-block container'>
        { title }
        { filters }
        { calendar }
      </div>
      <div className={ `event-block ${ displayLargeTiles ? '--exploded-tiles' : '--compact-tiles' }` }>
        <div className='grid mt-n2'>
          { events }
        </div>
      </div>
    </>
  );
};

class EventCard extends Component {
  playVideo = () => {
    this.video.play();
  };

  pauseVideo = () => {
    this.video.pause();
  };

  render() {
    const { event, shortlistButton } = this.props;
    return (
      <div
        className={ `sm+:c6 md+:c4 xl:c3 h-100 p4 ${ event.hasPageIntroText ? '--blurb' : event.hasPreviewVideo ? '--reveal' : '' } ` }
        onMouseOver={ event.hasPreviewVideo ? this.playVideo : null }
        onMouseOut={ event.hasPreviewVideo ? this.pauseVideo : null }
      >
        <div className='event-tile --zoom'>
          <div className='event-tile__media relative'>
            <a className='stretched-link' href={ event.url }>
              <img
                className='event-tile__image relative z-10'
                src={ event.previewImage.url }
                alt={ event.previewImage.title }
              />
            </a>
            { event.hasPreviewVideo ? (
              <video
                className='event-tile__video absolute z-0'
                muted
                loop
                playsInline
                src={ event.previewVideo.url }
                poster={ event.previewImage.url }
                preload='none'
                data-object-fit='cover'
                ref={ el => this.video = el }
              >
                <img src={ event.previewImage.url } alt='' />
              </video>
            ) : ('') }
          </div>
          <div className='event-tile__inner'>
            <div className='event-tile__text'>
              <h2 className='h3 event-tile__headline'>
                <a className='stretched-link' href={ event.url }>
                  { event.displayTitle ? (<span dangerouslySetInnerHTML={{ __html: event.displayTitle }} />) : (event.title) }
                </a>
              </h2>
              <h3 className='event-tile__tagline'>{ event.tagline }</h3>
              { event.canShortlist && shortlistButton }
              { event.hasPageIntroText ? (
                <div className='event-tile__blurb'><p dangerouslySetInnerHTML={{ __html: event.pageIntroText }} /></div>
              ) : ('') }
            </div>
            <div className='flags'>
              { event.tags.displayTags.map(tag => (
                <span key={ tag.slug } className='flag'>
                  { tag.name }
                </span>
              )) }
              { event.isSoldOut && (
                <span className='flag bg-red'>
                  Sold out
                </span>
              )}
              { event.isSellingFast && !event.isSoldOut && (
                <span className='flag bg-red'>
                  Selling fast
                </span>
              )}
              { event.hasStatus && (
                <span className={ `flag bg-${ event.statusColor }` }>
                  { event.eventStatus }
                </span>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const ExtraEventTile = ({ content, url }) => {
  return (
    <div className='provocation-tile aspect-ratio aspect-ratio--tile sm+:c6 md+:c4 xl:c3'>
      <div className='flex flex-column flex-jc-center sm+:flex-jc-end'>
        <h2>
          <a
            className='stretched-link'
            href={ url }
            dangerouslySetInnerHTML={{ __html: content }}
          />
        </h2>
      </div>
    </div>
  );
};

const FilterList = ({ filters }) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <>
      <div className='filter-group--mobile-controls --filters'>
        <div className='w-100'>
          <a className={ `link--stubby ${ isOpen ? 'collapse-control--open' : '' }` } onClick={ () => setIsOpen(!isOpen) }>
            <span>
              Browse by
              <i className='icon ml-2 triangle-down inline-block'>
                <Svg name='icon-triangle-down' width='10px' height='5px' className='color-black' />
              </i>
            </span>
          </a>
        </div>
      </div>
      <div className={ `filter-group collapse ${ isOpen ? 'collapsible-show' : '' }` }>
        <h6 className='filter-group__heading'> Browse by </h6>
        <ul className='filters-list'>
          { filters }
        </ul>
      </div>
    </>
  );
};

const Filter = ({ name, options, isCollapsed, onClick }) => {
  return (
    <li className='filter-item relative'>
      <a className={ `link--stubby ${ isCollapsed ? '' : '--collapse-opened' }` } onClick={ onClick }>
        <span>
          { name }
          <i className='icon ml-2'>
            <Svg name='icon-triangle-down' width='10px' height='5px' />
          </i>
        </span>
      </a>
      <ul className={ `filter__sub-nav ${ isCollapsed ? 'collapse' : '' }` }>
        { options }
      </ul>
    </li>
  );
};

const Option = ({ name, slug, image, isActive, onClick }) => {
  return (
    <li>
      { image && (
        <img src={ image.url } className='hidden' />
      ) }
      <a
        className={ `${ !isActive ? '--disabled' : '--abled' }` }
        onClick={ onClick }
      >
        <span>{ name }</span>
      </a>
    </li>
  );
};

const Modal = ({ parsedContent, modalClasses, onCloseCB }) => {
  return (
    <Overlay onCloseCB={ onCloseCB }>
      <div className='modal__overlay'>
        <div className={ `modal__container ${ modalClasses || '' }` }>
          { parsedContent }
        </div>
      </div>
    </Overlay>
  );
};

const ShortlistButton = ({ isShortlisted, isRemoveOption, isLargeBtn, isBannerBtn, onClick }) => {
  if (isRemoveOption) {
    return (
      <a className='link--reverse small color-grey' onClick={ onClick }>Remove from shortlist</a>
    );
  } if (isLargeBtn) {
    return (
      <button
        className='btn btn--shortlist btn--secondary btn--medium w-100 md:mt-5'
        onClick={ onClick }
      >
        { isShortlisted ? (
          <i className='relative top-n1px'>
            <Svg name='icon-heart-filled' className='pr-1' width='25px' height='24px' />
          </i>
        ) : (
          <i className='relative top-n1px'>
            <Svg name='icon-heart-stroke' className='pr-1' width='25px' height='24px' />
          </i>
        ) }
        <span className='pl-2 text-sm'>
          { isShortlisted ? ('Shortlisted') : ('Shortlist') }
        </span>
      </button>
    );
  } if (isBannerBtn) {
    return (
      <a className='link--stubby' onClick={ onClick }>
        { isShortlisted ? (
          <span title='Remove?'>
            <i className='inline-block pr-1 relative top-n1px'>
              <Svg name='icon-heart-small-filled' className='pr-1' width='18px' height='18px' />
            </i>
            Shortlisted
          </span>
        ) : (
          <span>
            <i className='inline-block pr-1 relative top-n1px'>
              <Svg name='icon-heart-small-stroke' className='pr-1' width='18px' height='18px' />
            </i>
            Shortlist
          </span>
        ) }
      </a>
    );
  }

  return (
    <button className='event-tile__shortlist' onClick={ onClick }>
      { isShortlisted ? (
        <Svg name='icon-heart-filled' width='26px' height='25px' />
      ) : (
        <Svg name='icon-heart-stroke' width='26px' height='25px' />
      ) }
    </button>
  );
};

const ShortlistCount = ({ itemsCount, url }) => {
  return (
    <a href={ url } className='nav__shortlist'>
      <Svg name='icon-heart-stroke' width='26px' height='25px' />
      { (itemsCount > 0) && (
        <span className='shortlist-count notification'>{ itemsCount }</span>
      ) }
    </a>
  );
};

const ShortlistAlert = observer(({ store }) => {
  const { buyingSessionsCount } = store;
  if (buyingSessionsCount > 2) {
    return (
      <div>
        <p className='font-bold small'>Almost there! 🎉</p>
        <p className='tiny'>
Purchase 3 or more tickets, and you'll go in the weekly draw to win a $300 Festival voucher and
          <span className='nowrap'>3 tickets</span>
          {' '}
gifted to charity.
          <a className='nowrap' href='/deals/power-of-three'>Read more</a>
        </p>
      </div>
    );
  }
  return (
    <div>
      <p className='font-bold small'>The Power of Three</p>
      <p className='tiny'>
Purchase 3 or more tickets and you'll go in the weekly draw to win a $300 Festival voucher and
        <span className='nowrap'>3 tickets</span>
        {' '}
gifted to a charity.
        <a className='nowrap' href='/deals/power-of-three'>Read more</a>
      </p>
    </div>
  );
});

const ShortlistFormSubmit = ({ isDisabled }) => {
  return (
    <button
      className='btn btn--reverse btn--large btn--full md+:mt-8'
      type='submit'
      disabled={ isDisabled }
    >
      Buy tickets
    </button>
  );
};

const ShortlistFormWrapper = observer(({ cartCount, cartItems, form, parsedContent }) => {
  return (
    <div className='bg-black color-white antialiased'>
      { parsedContent }
      <div className='flex flex-nowrap flex-ai-center p4 pt-0 md:p12 md:pt-0 md+:p8 md+:block'>
        <h6 className='small flex-grow-1 text-center md+:text-left'>
          { cartCount === 0 || cartCount > 1 ? (
            <>
              <span className='large pr-1'>{ cartCount }</span>
              {' '}
              Events added
            </>
          ) : (
            <>
              <span className='large pr-1'>{ cartCount }</span>
              {' '}
              Event added
            </>
          ) }
        </h6>
        <hr className='bg-color-grey-20 hidden md+:block' />
        <div className='hidden md+:block'>
          { cartItems.map(item => {
            return (
              <div key={ item.eventId }>
                <p className='small mb-4'>
                  <span className='font-bold'>
                    { item.eventTitle }
                  </span>
                  <br />
                  <span className='tiny color-grey-20'>
                    { item.selectedSession.startDate.format('D MMMM, LT') }
                    {' - '}
                    { item.selectedSession.venueName }
                  </span>
                </p>
              </div>
            );
          }) }
        </div>
        <div className='flex-grow-1'>
          { form }
        </div>
      </div>
    </div>
  );
});


const ShortlistBuyButton = ({ item }) => {
  const onClick = () => {
    if (item.isChooseYourPrice) {
      initChooseYourPriceApp(item.eventId);
    } else {
      window.location = item.bookingUrl;
    }
  };

  return (
    <div>
      <button
        className='btn btn--medium btn--default btn--add-and-remove'
        onClick={ onClick }
      >
          Buy tickets
      </button>
    </div>

  );
};

const ShortlistRemoveButton = ({ onClick }) => {
  return (
    <button className='link--stubby pl-0 mt-2 block' onClick={ onClick }>
      <span>
        {/* <i className='mr-2'> */}
        {/*  <Svg name='icon-close' width='12px' height='12px' /> */}
        {/* </i> */}
        Remove from shortlist
      </span>
    </button>
  );
};

const ShortlistSessionSelect = ({ id, sessions, defaultValue, onChange, isDisabled }) => {
  return (
    <select className='mr-2' id={ id } defaultValue={ defaultValue } onChange={ onChange } disabled={ isDisabled }>
      <option value='' disabled>Please select a session</option>
      { sessions.map(session => {
        return (
          <option key={ session.id } value={ session.id } disabled={ session.status === 'sold-out' }>
            { session.startDate.format('D MMMM, LT') }
            {' - '}
            { session.venueName }
            { session.status === 'sold-out' ? ' (Sold out)' : '' }
          </option>
        );
      }) }
    </select>
  );
};

const Title = ({ title, currentFilter, unsetFilter, currentDate, unsetDate }) => {
  return (
    <h1 className='filter-heading'>
      { currentFilter && (
        <a
          title='Remove filter'
          className='filter-tag'
          onClick={ unsetFilter }
        >
          <span className='pr-6'>{ currentFilter.name }</span>
          <i className='color-white'>
            <Svg className='' name='icon-close' width='16px' height='16px' />
          </i>
        </a>
      ) }
      { currentDate && (
        <>
          { currentFilter && (<> on </>) }
          <a
            title="Remove 'Music' filter"
            className='filter-tag'
            onClick={ unsetDate }
          >
            <span className='pr-6'>{ currentDate.format('ddd, D MMM') }</span>
            <i className='color-white'>
              <Svg className='' name='icon-close' width='16px' height='16px' />
            </i>
          </a>
        </>
      ) }
      { !currentFilter && !currentDate && (
        <>
          <span className='filter-tag --faux'>
            { title }
          </span>
        </>
      ) }
    </h1>
  );
};

const VideoButton = ({ buttonContent, buttonClass, buttonIcon, onClick }) => {
  return (
    <span className={ buttonClass } onClick={ onClick }>
      <span>
        { buttonIcon && (
          <i className='inline-block pr-1 relative top-n2px'>
            <Svg name={ buttonIcon } width='12px' height='12px' />
          </i>
        ) }
        { buttonContent || 'Video' }
      </span>
    </span>
  );
};

const VideoOverlay = ({ videoSrc }) => {
  return (
    <Overlay>
      <div className='modal__overlay'>
        <div className='modal__container --large aspect-ratio aspect-ratio--16by9 rounded-none bg-black'>
          <iframe className='media__video-player' width='100%' height='100%' src={ videoSrc } frameBorder='0' />
        </div>
      </div>
    </Overlay>
  );
};

export {
  Calendar,
  CalendarDay,
  CalendarMonth,
  EventList,
  EventCard,
  ExtraEventTile,
  FilterList,
  Filter,
  Option,
  Modal,
  ShortlistButton,
  ShortlistCount,
  ShortlistAlert,
  ShortlistFormSubmit,
  ShortlistFormWrapper,
  ShortlistBuyButton,
  ShortlistRemoveButton,
  ShortlistSessionSelect,
  Title,
  VideoButton,
  VideoOverlay,
};
